import { marked } from "marked";
import { assistantFileName } from "./assistantFileName";

const FILE_EXT = /\.(pdf|pptx?|docx?|xlsx?|csv|tsv|txt|md|zip|gz|tar|7z|key|mp3|wav|m4a|ogg|mp4|mov|webm)$/i;

/** Only names an already-attached URL. Ordinary Markdown links remain inline;
 * no remote metadata request, content sniffing or download promise is made. */
export function attachedLink(fileRef: string, markdown = ""): {
  title: string; domain: string; filename?: string;
} {
  const url = new URL(fileRef);
  const domain = url.hostname;
  const filename = assistantFileName(fileRef);
  if (FILE_EXT.test(filename)) return { title: filename, domain, filename };
  let title = "";
  // Use the agent's explicit label for this exact address, never another link's.
  // Bounded parsing is presentation only; it does not alter the saved response.
  marked.walkTokens(marked.lexer(markdown.slice(0, 100_000)), token => {
    if (title || token.type !== "link" || token.href !== fileRef) return;
    const label = token.text.trim();
    if (label && label !== fileRef && !/^https?:\/\//i.test(label)) title = label;
  });
  if (!title) {
    title = domain === "drive.google.com" ? "Google Drive file"
      : domain === "docs.google.com" && url.pathname.startsWith("/presentation/") ? "Google Slides presentation"
      : domain === "docs.google.com" && url.pathname.startsWith("/spreadsheets/") ? "Google Sheets spreadsheet"
      : domain === "docs.google.com" ? "Google document"
      : /^drive\./i.test(domain) ? "Shared file" : "Open shared link";
  }
  return { title: title.slice(0, 255), domain };
}
